import apiClient from '../client';

interface LoginRequest {
  username: string;
  password: string;
}

interface LoginResponse {
  success: boolean;
  message: string;
  data: { username: string };
}

interface MeResponse {
  success: boolean;
  data: { username: string; role: string };
}

export const authApi = {
  async login(credentials: LoginRequest): Promise<{ username: string }> {
    const res = await apiClient.post<LoginResponse>('/auth/login', credentials);
    return res.data.data;
  },

  async logout(): Promise<void> {
    await apiClient.post('/auth/logout');
  },

  async me(): Promise<{ username: string; role: string }> {
    const res = await apiClient.get<MeResponse>('/auth/me');
    return res.data.data;
  },
};
